import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import * as moment from 'moment/moment';
import { PolicyService } from 'app/FunctionalModules/PolicyIssuance/policy.service';
import {
  ComponentOutputDO,
  InteractService,
  AppMetadataHandler,
  CommonUtilty
} from 'app';
import { DataTransformService } from 'app/ViewModules/shared-services/data-transform/data-transform.service';
import { HttpClient } from '@angular/common/http';
import { ApiRequestService } from 'app/BaseFramework/core/http/api-request.service';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
  selector: 'app-inbox-card',
  templateUrl: './inbox-card.component.html',
  styleUrls: ['./inbox-card.component.scss']
})
export class InboxCardComponent implements OnInit {
  _currentComponentName = 'InboxCardComponent'
  _openingCase
  constructor(
    private interactService: InteractService,
    private viewContainerRef: ViewContainerRef,
    public appMetadataHandler: AppMetadataHandler,
    public commonUtility: CommonUtilty,
    public policyService : PolicyService,
    public dataTransformService : DataTransformService,
    public http : HttpClient,
    public apiRequestService : ApiRequestService,
    public msg : NzMessageService
  ) { }

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  _inboxType
  @Input()
  set InboxType(value: any) {
    if (value) {
      this._inboxType = value
      this.inboxFullPrivilege = !!!(this._inboxType == 'partner-inbox')
    }
  }
  get InboxType() {
    return this._inboxType
  }

  @Input() filteredMetaDataMap: any;

  private _inputDataInboxCard = null;
  @Input()
  set inputDataInboxCard(value: any) {
    if (value) {
      this._inputDataInboxCard = value;
      this.setInboxCardMetaData(this._inputDataInboxCard.serviceTask);
    }
  };
  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  public inboxFullPrivilege = true
  public workQueueItem: any;
  isLoading
  ngOnInit() {
    this.workQueueItem = this._inputDataInboxCard
    this.source = this.sourceListData[Math.floor(Math.random() * this.sourceListData.length)]
    // this.getProposalIODetails();
    
  }

  sourceListData = ['Paper', 'Portal', 'Bulk', 'Mobile', 'Chatbot', 'Whatsapp', 'Facebook']
  source

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      // dateString = moment(rawDate).format('DD MMM YYYY HH:mm:ss');
      // dateString = moment(rawDate).format('DD MMM YYYY hh:mm A');
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);

    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  openTransactionDetails(serviceTask: any, entityGuid: any, taskId: any, selectedProduct) {
    let data = {};
    this._openingCase = true
    data = { "serviceTask": serviceTask, "entityGuid": entityGuid, "taskId": taskId, "selectedProduct": selectedProduct }
    this.EmitComponentOutput(data);
  }

  MetaDataMapdummy
  visibleInboxAttributes
  setInboxCardMetaData(serviceTask) {
    this.MetaDataMapdummy = this.filteredMetaDataMap || this.appMetadataHandler.inboxCardMetaData[serviceTask] || this.appMetadataHandler.inboxCardMetaData.default;
    this.visibleInboxAttributes = Object.assign([], this.MetaDataMapdummy).filter(
      item => item.isVisible
    )

  }

  taskArray = [];
  emitSelectedTask(event, data) {
    this.interactService.sendTaskTOWorkBench(data, event);
  }

  dataset =[
    {
    "fraudScore": 25,
    "propensity": 10,
    "key":"9000000",
    },
    {
    "fraudScore": 11,
    "propensity": 35,
    "key":"8000000",
    },
    {
    "fraudScore": 25,
    "propensity": 54,
    "key":"10000000",
    },
  ]

  fraudDeatils = [];
  fraudScore = 0;
  propensity=0;
  modelPrediction = null;
  recommendation = null;
  enableAnalyticsPanel = false
  setScore(item){
    // if(item && this.commonUtility.isArrayIterable(this.dataset)){
    //   this.dataset.forEach(ele=>{
    //     if(item.sumInsured && ele.key == item.sumInsured){
    //       this.fraudScore = ele.fraudScore;
    //       this.propensity = ele.propensity;
    //     }
    //   })
    // }
    this.enableAnalyticsPanel = true;
    this.getProposalData();
    this.enableRiskSummary = false;
  }
  
  fetchFraudDeatils(){
    let url = 'fetchBatchLog'
    let pathVariables = [];
    pathVariables.push(this.workQueueItem.proposalNum);
    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(resp =>{
      if(resp)
        this.fraudDeatils = resp
      else this.msg.error("Server Error : Please check with system administrator")

      if(this.fraudDeatils && this.commonUtility.isArrayIterable){
        this.fraudDeatils.forEach(detail => {
          if(detail.batchName && detail.batchName == 'PROBABILITY'){
            let propensityRespData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
            this.propensity = propensityRespData[0] ? propensityRespData[0].claim_prediction_years ? propensityRespData[0].claim_prediction_years : null : null;
            this.dataTransformService.propensityRisk = this.propensity;
          }
          if(detail.batchName && detail.batchName == 'FWA_RISK'){
            let fraudScoreRespData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
           this.fraudScore = fraudScoreRespData[0] ? fraudScoreRespData[0].predictionProbabilityPercent ? fraudScoreRespData[0].predictionProbabilityPercent : null : null;
            this.modelPrediction = fraudScoreRespData[0] ? fraudScoreRespData[0].modelPrediction ? fraudScoreRespData[0].modelPrediction : null : null;
            this.dataTransformService.fraudRisk = this.modelPrediction;
            this.dataTransformService.fraudScore = this.fraudScore;
            this.recommendation = fraudScoreRespData[0] ? fraudScoreRespData[0].overallInvestigationRecommendation ? fraudScoreRespData[0].overallInvestigationRecommendation : null : null;
            this.dataTransformService.riskRecommendation = this.recommendation;
          }
          if(detail.batchName && detail.batchName == 'UW_RISK'){
            let UWRiskData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
            this.dataTransformService.riskSummary = UWRiskData[0]['content'] ? UWRiskData[0]['content'] : null;
            // this.modelPrediction = UWRiskData[0] ? UWRiskData[0].modelPrediction ? fraudScoreRespData[0].modelPrediction : null : null;
            // this.recommendation = UWRiskData[0] ? UWRiskData[0].overallInvestigationRecommendation ? fraudScoreRespData[0].overallInvestigationRecommendation : null : null;
          }
        })
      }
    })
  }

  activityPanelOpen = false;
  activityPanel(status) {
    this.activityPanelOpen = !!status;
  }
  isRiskSummaryLoading : boolean = false
  getProposalIODetails(){
    // this.isRiskSummaryLoading = true;
    // this.enableRiskSummary = !this.enableRiskSummary;
    this.policyService.getPolicyByGuid(this.workQueueItem.entityGuid).
    subscribe(resp => {
      if (resp && Object.entries(resp).length > 0) {
       this.policyData = resp;
       if(this.commonUtility.isArrayIterable(resp['questionnaires'])){
        this.questionCdListFromQuestionnaire = this.getQuestionCdList(resp['questionnaires'])
        // this.getListOfQuestionMasterCds(this.questionCdListFromQuestionnaire, resp)
        // this.fetchFraudDeatils();
      }
      }
      this.isRiskSummaryLoading = false;
    })
  }
  data = null
  getProposalData(){
    this.enableAnalyticsPanel = true;
    this.policyService.getPolicyByGuid(this.workQueueItem.entityGuid).
    subscribe(resp => {
      if (resp && Object.entries(resp).length > 0) {
       this.data = resp;
       if(this.commonUtility.isArrayIterable(resp['questionnaires'])){
        this.questionCdListFromQuestionnaire = this.getQuestionCdList(resp['questionnaires'])
        // this.getListOfQuestionMasterCds(this.questionCdListFromQuestionnaire, resp)
        // this.fetchFraudDeatils();
      }
      }
      this.isRiskSummaryLoading = false;
    })
  }
  questionCdListFromQuestionnaire = []
  getQuestionCdList(questionnaire) {
   let questionCdList = []
   if (this.commonUtility.isArrayIterable(questionnaire)) {
     questionnaire.forEach(questionItem => {
       if (this.commonUtility.isArrayIterable(questionItem.questionnaireDtls)) {
         questionItem.questionnaireDtls.forEach(questionnaireDtl => {
           if (questionnaireDtl.questionCd)
             questionCdList.push(questionnaireDtl.questionCd)
         });
       }
     });
   }
   return questionCdList
 }
  getListOfQuestionMasterCds(listOfQuestionCds, IO){
    const payload = {
      "params": listOfQuestionCds // send the questionCd
    }
    this.apiRequestService.postCallWithAPIMapper('fetchByQuestionCd', payload).subscribe(resp=>{
      if(this.commonUtility.isArrayIterable(resp)){
         this.getRiskSummarizationDetails(IO, resp)
      }
    })
  }
  riskSummarizationContent = null;
  riskSummarizationLoader = false;
  riskSummarizationApiError = false;
 getRiskSummarizationDetails(IO, listOfQuestion) {
     this.riskSummarizationLoader = true;
     // API: https://product-dev-services.metamorphosys.co.in/fwa-health/nbu_risk_summary
     // Request: 
     // {
     //    "product_type":"LIFE_Claims_Dev",
     //    "business_process":"FWARISKANALYSIS",
     //    "module_name":"VisionIntelligence",
     //    "model_id":"mistral",
     //    "input_data":"Case Summary:  Applicant Name: Smith Jones  Age: 56   Occupation: Govt job  Residential Location: Chennai     Hobbies: Reading    Medical History:  Hypertension: No  Family Medical History: No Smoking Status: Non-smoker  Alcohol Consumption: No      Tobacco Consumption: Yes  Recent Health Check-Up Results: normal BMI, healthy cholesterol levels, no signs of diabetes. Financial Information:  Annual Income: Rs 2000000  Existing Debts: No loan   Insurance History: Yes, previous health insurance claims. "
     // }  
     // Sample JSON data (Assuming the JSON data is stored in a variable named jsonData)
     const jsonData = `Your JSON data here`;
     const headers = { 'Content-Type': 'application/json' };
     // Parsing JSON
     const data = IO;
 
     // Helper function to calculate age from date of birth
 
 
     // Extracting required information
     const clientDO = data.clientDOs?.[0] || {};
     const personDO = clientDO.personDO || {};
 
     const applicantName = `${personDO.firstName || ''} ${personDO.middleName || ''} ${personDO.lastName || ''}`.trim();
     const dob = new Date(personDO.dateOfBirth);
     const age = this.calculateAge(dob);
     const occupation = clientDO.occupationCd || "N/A";
     const residentialLocation = clientDO.city || "N/A";
     const hobbies = "Reading"; // Placeholder as hobbies are not in JSON
 
     // Extracting medical history information
     const questionnaires = data.questionnaires?.[0]?.questionnaireDtls || [];
     const medicalHistory = this.getMedicalHistory(questionnaires,listOfQuestion)
 
     // Adding additional hardcoded medical history
     medicalHistory["Hypertension"] = "No";
     medicalHistory["Family Medical History"] = "No";
     medicalHistory["Recent Health Check-Up Results"] = "normal BMI, Calculated healthy cholesterol levels, no signs of diabetes";
 
     // Extracting financial information
     const annualIncome = clientDO.income || "N/A";
     const existingDebts = "No loan"; // Placeholder as debts information is not in JSON
     const insuranceHistory = "Yes, previous health insurance claims."; // Placeholder
 
     // Preparing the case summary
     const caseSummary = {
       "Applicant Name": applicantName,
       "Age": age,
       "Occupation": occupation,
       "Residential Location": residentialLocation,
       "Hobbies": hobbies,
       "Medical History": medicalHistory,
       "Financial Information": {
         "Annual Income": annualIncome,
         "Existing Debts": existingDebts,
         "Insurance History": insuranceHistory
       }
     };
 
     console.log("Rish Summarization case summary = ", caseSummary);
 
     let payload = {
       "product_type": "LIFE_Claims_Dev",
       "business_process": "FWARISKANALYSIS",
       "module_name": "VisionIntelligence",
       "model_id": "'palm2-32k",
      //  "input_data": caseSummary
     }
    //  let URL = `https://product-fwa.metamorphosys.co.in/fwa-health/nbu_risk_summary`
    // let URL = `https://product-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports_v1`
    let URL = `https://product-dev-v2-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports`
     this.http.post(URL, payload, { headers })
       .subscribe(jsonResp => {
         console.log("summarization response = ", jsonResp)
         this.riskSummarizationContent = jsonResp['content'];
         this.dataTransformService.riskSummarizationResponse = jsonResp;
         this.dataTransformService.riskSummary = this.riskSummarizationContent;
         this.riskSummarizationLoader = false;
       }, err => {
         this.riskSummarizationLoader = false;
         this.riskSummarizationApiError = true;
         // this.msg.error('Server Error - Technical issue occurred, please contact IT Support.', { nzDuration: 4000 })
       });
 }
 calculateAge(dob) {
  const birthDate = new Date(dob);
  const difference = Date.now() - birthDate.getTime();
  const ageDate = new Date(difference);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

getMedicalHistory(questionnaires, listOfQuestion){
let acc = {}
if(this.commonUtility.isArrayIterable(questionnaires) && this.commonUtility.isArrayIterable(listOfQuestion)){
  questionnaires.forEach(item=>{
    listOfQuestion.forEach(ele=>{
      if(item.questionCd === ele.questionCd && this.commonUtility.isArrayIterable(ele.questionMsgDO)){
        ele.questionMsgDO.forEach(ques=>{
          acc[ques.message] = item.responseCd || "N/A";
        })
      }
    })
  })
  // questionnaires.reduce((acc, q) => {
  //   acc[q.vocabularyCd] = q.responseDtl || "N/A";
  //   return acc;
  // }, {});
}
return acc;
}
  enableRiskSummary = false;
  policyData = null
  openRiskSummary(status){
    this.isRiskSummaryLoading = true;
    this.enableRiskSummary = !this.enableRiskSummary;
    this.enableAnalyticsPanel = false;
    this.getProposalIODetails();
  }
  getDO(IO) {
    if (IO)
      return IO['intimationDO'] || IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'] || IO['proposalDO'] || IO['caseDO'];
    else
      null
  }
  
  getClinetDO(IO) {
    let output = {}
    let DO = this.getDO(IO)
    if (DO != null && (IO['intimationDO'] || IO['claimDO'] || IO['proposalDO'])) {
      let clientDO = IO['clientDOs'];
      // let clientRoles = IO['intimationDO']['claimClientRoles'] || IO['claimDO']['claimClientRoles'];
      let clientRoles: any = [];
      if (IO['intimationDO'])
        clientRoles = IO['intimationDO']['claimClientRoles']

      if (IO['claimDO'])
        clientRoles = IO['claimDO']['claimClientRoles'];

      if (IO['proposalDO'])
        clientRoles = IO['proposalDO']['proposalClients'];

      let insureClientRef = clientRoles.find(item => {
        if (item)
          return item['roleCd'] === 'INSURED';
      }) || []

      if(this.commonUtility.isArrayIterable(clientDO)){
        output = clientDO.find(item => {
          if (item)
            return item['guid'] === insureClientRef.clientRefGuid;
        }) || []
      }else{
        output = [];
      }
     
    }


    return output
  }
}

